import { createContext, ReactNode, useContext } from "react";

import { useFilterReferralSetting } from "./filter-referral-setting.hook";

const FilterReferralSettingContext = createContext(
  {} as ReturnType<typeof useFilterReferralSetting>
);
export function useFilterReferralSettingContext() {
  return useContext(FilterReferralSettingContext);
}

interface FilterReferralSettingProviderProps {
  children: ReactNode;
}
export function FilterReferralSettingProvider({
  children,
}: FilterReferralSettingProviderProps) {
  return (
    <FilterReferralSettingContext.Provider value={useFilterReferralSetting()}>
      {children}
    </FilterReferralSettingContext.Provider>
  );
}